import { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { Help } from '@clds/icon';
import { DropdownMobileMenu } from '../../components/DropdownMobileMenu/DropdownMobileMenu';
import { PrimaryMenuItemMobile } from '../../components/PrimaryMenu';
import { MENU_ITEM_ICON_SIZE } from '../../ApplicationWrapper.const';
import { messages } from '../../i18n';
import { HelpDropdownMenuItems } from './HelpDropdownMenuItems';

interface HelpDropdownMenuTriggerMobileProps {
  onClick?: () => void;
}

export const HelpDropdownMenuTriggerMobile = forwardRef<HTMLButtonElement, HelpDropdownMenuTriggerMobileProps>((props, ref) => (
  <PrimaryMenuItemMobile ref={ref} data-test-specifier="help-menu" analyticsMessage="help menu mobile" {...props}>
    <Help size={MENU_ITEM_ICON_SIZE} />
  </PrimaryMenuItemMobile>
));

export const HelpDropdownMenuMobile = () => {
  const { formatMessage } = useIntl();

  return (
    <DropdownMobileMenu headerTitle={formatMessage(messages.helpMobileMenuHeader)} trigger={<HelpDropdownMenuTriggerMobile />}>
      <HelpDropdownMenuItems isMobile={true} />
    </DropdownMobileMenu>
  );
};
